import { useAui } from '@assistant-ui/react';

import type { ToolSidecarEntry } from '#plugin-chat/lib/tool/message-formatters.ts';

/**
 * The assistant-ui model-context tools map, narrowed to the
 * {@link ToolSidecarEntry} metadata `<Tool>` attaches to each entry.
 * Keyed by wire tool name.
 */
export type ToolsMap = Record<string, ToolSidecarEntry | undefined> | undefined;

/**
 * Read the assistant-ui model-context tools map. Single source of truth
 * for the cast over the assistant-ui registry shape — the read-side
 * mirror of the `<Tool>` registration cast. Consumers access sidecar
 * fields as plain typed properties (`tools?.[name]?.labelValues`).
 */
export function useToolsMap(): ToolsMap {
  const aui = useAui();
  return aui.modelContext().getModelContext().tools as ToolsMap;
}
